import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

/**
 * Floating-label input. `type="password"` gets a show/hide toggle.
 * The label floats via CSS (:placeholder-shown), so placeholder must stay " ".
 */
export default function AuthField({ id, label, type = 'text', error, inputRef, ...inputProps }) {
    const [revealed, setRevealed] = useState(false);
    const isPassword = type === 'password';
    const msgId = `${id}-msg`;

    return (
        <div>
            <div className={`ta-field${isPassword ? ' has-toggle' : ''}${error ? ' is-invalid' : ''}`}>
                <input
                    id={id}
                    ref={inputRef}
                    className="ta-input"
                    type={isPassword && revealed ? 'text' : type}
                    placeholder=" "
                    aria-invalid={error ? true : undefined}
                    aria-describedby={error ? msgId : undefined}
                    {...inputProps}
                />
                <label className="ta-label" htmlFor={id}>{label}</label>
                {isPassword && (
                    <button
                        type="button"
                        className="ta-toggle"
                        onClick={() => setRevealed(r => !r)}
                        aria-label={revealed ? 'Hide password' : 'Show password'}
                        aria-pressed={revealed}
                    >
                        {revealed ? <FiEyeOff size={19} /> : <FiEye size={19} />}
                    </button>
                )}
            </div>
            {error && <p id={msgId} className="ta-field-msg">{error}</p>}
        </div>
    );
}
